<template lang="pug">
fragment
    nav.navigation
        .navigation-logo
            router-link(:to="{ name: 'home' }")
                img(src="@/assets/logo.svg", alt="Logo")
        ul.navigation-bar-desktop
            li.nav-item(data-cursor-sticky)
                router-link(
                    :to="{ name: 'home' }",
                    :class="{ 'router-link-exact-active': this.$route.name == 'home' }"
                ) Home
            li.nav-item(data-cursor-sticky)
                router-link(:to="{ name: 'works' }") Works
            li.nav-item.spacer
            li.nav-item.align-right.contact-link(data-cursor-sticky)
                a.contactButton(@click="contactClicked") Contact us
        ul.navigation-bar-mobile
            a(href="#", @click="toggleNavigation")
                span.lnr.lnr-menu
    nav.navigation-mobile(:class="{ shown: isMobileVisible }")
        ul.navigation-list-mobile
            li.nav-item
                router-link(:to="{ name: 'home' }") Home
            li.nav-item
                router-link(:to="{ name: 'works' }") Works
            li.nav-item
                a.contactButton(@click="contactClicked") Contact us
        a.close-button(href="#", @click="toggleNavigation")
            span.lnr.lnr-cross
</template>

<script>
import { EventBus } from "@/events/global-bus.js";
export default {
    name: "navigation",
    data: function () {
        return {
            isMobileVisible: false,
        };
    },
    methods: {
        toggleNavigation(e) {
            e.preventDefault();
            this.isMobileVisible = !this.isMobileVisible;
        },
        contactClicked(e) {
            e.preventDefault();
            let currentRoute = this.$route.name;
            // alert(currentRoute);
            if (currentRoute == "home") {
                EventBus.$emit("scrollToContactForm");
            } else {
                this.$router.push({ name: "home", query: { c: true } });
            }
        },
    },
};
</script>

<style lang="scss">
.navigation {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    pointer-events: all;

    .navigation-logo {
        margin-right: $navigation-element-spacing * 2;
        img {
            width: $navigation-logo-size;
            height: $navigation-logo-size;
        }
    }

    .navigation-bar-desktop,
    .navigation-bar-mobile {
        flex-grow: 1;
    }

    .navigation-bar-mobile {
        display: none;
        justify-content: flex-end;
        .lnr-menu {
            font-size: 3.4rem;
        }
    }

    .navigation-bar-desktop {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .nav-item {
            display: inline-block;
            font-weight: 700;
            color: $cl-grey;
            font-size: 1.8rem;

            &:not(:last-child) {
                margin-right: $navigation-element-spacing;
            }

            &.spacer {
                flex-grow: 1;
            }

            a {
                padding-bottom: 0.4em;
            }

            .active:not(.contactButton),
            .router-link-exact-active:not(.contactButton) {
                color: $cl-red;
                position: relative;

                &::after {
                    bottom: 0;
                    height: 2px;
                    background-color: $cl-red;
                    left: 0;
                    width: 2rem;
                    content: "";
                    position: absolute;
                }
            }
        }
    }

    @include respond-below(md) {
        .navigation-bar-desktop {
            display: none;
        }

        .navigation-bar-mobile {
            display: flex;
        }
    }
}

.navigation-mobile {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: transparentize($cl-grey, 0.05);
    color: white;
    font-weight: 700;
    font-size: 4rem;
    display: none;

    &.shown {
        display: flex;
        animation: showMobileNavigation;
        animation-duration: 200ms;
        animation-fill-mode: forwards;
    }

    .navigation-list-mobile {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;
        .nav-item {
            .active:not(.contactButton),
            .router-link-exact-active:not(.contactButton) {
                color: $cl-red;
                position: relative;
                padding-bottom: 0.4rem;

                &::after {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    content: "";
                    height: 2px;
                    background-color: $cl-red;
                    left: 0;
                }
            }
            &:not(:last-child) {
                margin-bottom: 1rem;
            }
        }
    }

    .close-button {
        position: absolute;
        color: white;
        font-size: 3.4rem;
        top: $body-padding-mobile-y;
        right: $body-padding-mobile-x;
    }
}

@keyframes showMobileNavigation {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>